import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, PageService, ParserService} from '@gallaghercp/core-frontend';

export class PageCategories {
    id!: number;
    name!: string;
}

@Component({
    standalone: false,
    selector: 'core-block-category-list',
    templateUrl: './block-category-list.component.html',
})

export class BlockCategoryListComponent extends BlockAbstractComponent implements OnInit {
    pageCategories!: PageCategories[];

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }

    override ngOnInit() {
        super.ngOnInit();
        this.getCurrentPage();
    }

    getCurrentPage() {
        const currentPage = this.pages.getCurrentPage();
        const categories = currentPage.categories;
        const categoryNames = currentPage.categoryNames;
        let setCategories: { id: any; name: any; }[] = [];

        categories.forEach((id: any, index: number) => {
            if (categoryNames) {
                setCategories.push({
                    id: id,
                    name: categoryNames[index]
                });
            }
        });

        this.pageCategories = setCategories;
    }

}
